// Subject Autocomplete functionality
document.addEventListener('DOMContentLoaded', function() {
  const subjectInput = document.getElementById('subject-autocomplete-input');
  const subjectIdField = document.getElementById('quiz_generator_quiz_attributes_subject_id');
  const dropdownContainer = document.getElementById('subject-autocomplete-dropdown');
  
  if (!subjectInput || !subjectIdField || !dropdownContainer) return;

  let debounceTimer;
  let selectedIndex = -1;
  let suggestions = [];

  // Create dropdown element
  const dropdown = document.createElement('div');
  dropdown.className = 'autocomplete-dropdown';
  dropdown.style.display = 'none';
  dropdownContainer.appendChild(dropdown);

  // Debounced search function
  function searchSubjects(query) {
    if (query.length < 2) {
      hideDropdown();
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetch(`/subjects/search?q=${encodeURIComponent(query)}`, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      .then(response => response.json())
      .then(data => {
        suggestions = data;
        displaySuggestions(data, query);
      })
      .catch(error => console.error('Error searching subjects:', error));
    }, 300);
  }

  // Display suggestions in dropdown
  function displaySuggestions(subjects, query) {
    dropdown.innerHTML = '';
    selectedIndex = -1;

    if (subjects.length === 0) {
      // Show option to create new subject
      const createOption = document.createElement('div');
      createOption.className = 'autocomplete-item create-new';
      createOption.innerHTML = `
        <i class="fas fa-plus-circle me-2"></i>
        Create new subject: "<strong>${escapeHtml(query)}</strong>"
      `;
      createOption.addEventListener('click', () => createNewSubject(query));
      dropdown.appendChild(createOption);
    } else {
      // Show existing subjects
      subjects.forEach((subject, index) => {
        const item = document.createElement('div');
        item.className = 'autocomplete-item';
        item.textContent = subject.name;
        item.dataset.id = subject.id;
        item.dataset.index = index;
        
        item.addEventListener('click', () => selectSubject(subject));
        item.addEventListener('mouseenter', () => selectedIndex = index);
        
        dropdown.appendChild(item);
      });

      // Add create new option at the end if query doesn't exactly match
      const exactMatch = subjects.some(s => s.name.toLowerCase() === query.toLowerCase());
      if (!exactMatch) {
        const separator = document.createElement('div');
        separator.className = 'autocomplete-separator';
        dropdown.appendChild(separator);

        const createOption = document.createElement('div');
        createOption.className = 'autocomplete-item create-new';
        createOption.innerHTML = `
          <i class="fas fa-plus-circle me-2"></i>
          Create new subject: "<strong>${escapeHtml(query)}</strong>"
        `;
        createOption.dataset.index = subjects.length;
        createOption.addEventListener('click', () => createNewSubject(query));
        createOption.addEventListener('mouseenter', () => selectedIndex = subjects.length);
        dropdown.appendChild(createOption);
      }
    }

    showDropdown();
  }

  // Select existing subject
  function selectSubject(subject) {
    subjectInput.value = subject.name;
    subjectIdField.value = subject.id;
    hideDropdown();
    validateSubjectSelection(true);
  }

  // Create new subject
  function createNewSubject(name) {
    // Show loading state
    subjectInput.disabled = true;
    const originalValue = subjectInput.value;
    subjectInput.value = 'Creating subject...';

    fetch('/subjects', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ name: name })
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        alert('Error creating subject: ' + data.error);
        subjectInput.value = originalValue;
      } else {
        selectSubject(data);
      }
    })
    .catch(error => {
      console.error('Error creating subject:', error);
      alert('Failed to create subject. Please try again.');
      subjectInput.value = originalValue;
    })
    .finally(() => {
      subjectInput.disabled = false;
    });
  }

  // Show/hide dropdown
  function showDropdown() {
    dropdown.style.display = 'block';
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    selectedIndex = -1;
  }

  // Validate subject selection
  function validateSubjectSelection(isValid) {
    if (isValid) {
      subjectInput.classList.remove('is-invalid');
      subjectInput.classList.add('is-valid');
    } else {
      subjectInput.classList.remove('is-valid');
      subjectIdField.value = '';
    }
  }

  // Handle keyboard navigation
  function handleKeyboard(e) {
    const items = dropdown.querySelectorAll('.autocomplete-item');
    
    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
        updateHighlight(items);
        break;
        
      case 'ArrowUp':
        e.preventDefault();
        selectedIndex = Math.max(selectedIndex - 1, -1);
        updateHighlight(items);
        break;
        
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && items[selectedIndex]) {
          items[selectedIndex].click();
        }
        break;
        
      case 'Escape':
        hideDropdown();
        break;
    }
  }

  function updateHighlight(items) {
    items.forEach((item, index) => {
      if (index === selectedIndex) {
        item.classList.add('highlighted');
      } else {
        item.classList.remove('highlighted');
      }
    });
  }

  // Escape HTML to prevent XSS
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Event listeners
  subjectInput.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    searchSubjects(query);
    validateSubjectSelection(false);
  });

  subjectInput.addEventListener('keydown', handleKeyboard);

  // Hide dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!subjectInput.contains(e.target) && !dropdown.contains(e.target)) {
      hideDropdown();
    }
  });

  // Clear selection when input is cleared
  subjectInput.addEventListener('blur', () => {
    // Delay to allow click events to fire
    setTimeout(() => {
      if (!subjectIdField.value && subjectInput.value.trim() === '') {
        validateSubjectSelection(false);
      }
    }, 200);
  });
});

// Add styles for autocomplete
const style = document.createElement('style');
style.textContent = `
  .autocomplete-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background: var(--bg-darker);
    border: 1px solid var(--rail);
    border-top: none;
    border-radius: 0 0 0.375rem 0.375rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .autocomplete-item {
    padding: 0.75rem 1rem;
    cursor: pointer;
    color: var(--text-primary);
    transition: background-color 0.2s;
  }

  .autocomplete-item:hover,
  .autocomplete-item.highlighted {
    background-color: var(--wash);
  }

  .autocomplete-item.create-new {
    color: #3B82F6;
    font-weight: 500;
  }

  .autocomplete-separator {
    height: 1px;
    background-color: var(--rail);
    margin: 0.25rem 0;
  }

  .subject-autocomplete-wrapper {
    position: relative;
  }
`;
document.head.appendChild(style);